<script setup lang="ts">
import { ref } from 'vue'
import CreateRequestForm from './CreateRequestForm.vue'
import CreateRequestPreview from './CreateRequestPreview.vue'

interface RequisitionFormValues {
  requestType: 'BUY' | 'SELL' | ''
  requester: string
  amount: number | ''
  currency: string
  exchange: number | ''
  destinationAccount: string
  sourceCountry: string
  transferMethod: string[]
  validityPeriod: number | ''
  discount: string
  description: string
}

const props = defineProps<{
  countries: Array<{ label: string; value: string | number }>
  currencies: Array<{ label: string; value: string | number }>
  discountOptions: Array<{ label: string; value: string | number }>
  transferMethods: Array<{
    label: string
    value: string | number
  }>
}>()

const isOpen = ref(false)
const currentStep = ref(1)

const formValues = ref<RequisitionFormValues>({
  requestType: 'SELL',
  requester: '',
  amount: '',
  currency: '',
  exchange: '',
  destinationAccount: '',
  sourceCountry: '',
  transferMethod: [],
  validityPeriod: '',
  discount: '',
  description: '',
})

const onFormSubmit = (values: RequisitionFormValues) => {
  formValues.value = values
  currentStep.value = 2
}

const onBack = () => {
  currentStep.value = 1
}

const onCreateRequisition = () => {
  console.log('Create requisition:', formValues.value)

  // TODO: create requisition request
}

const onClose = () => {
  isOpen.value = false
  currentStep.value = 1

  formValues.value = {
    requestType: 'SELL',
    requester: '',
    amount: '',
    currency: '',
    exchange: '',
    destinationAccount: '',
    sourceCountry: '',
    transferMethod: [],
    validityPeriod: '',
    discount: '',
    description: '',
  }
}
</script>

<template>
    <div>
      <!-- TODO disabled in 2.1.4 -->
        <!-- <Button @click="isOpen = true" variant="outline" :isAdmin="true"
            class="px-3! rounded-lg! h-8! py-0 text-[13px] font-medium">
            <span class="flex items-center gap-2.5">
                <img src="/svg/circle-plus-primary.svg" />
                درخواست جدید
            </span>
        </Button> -->

        <OffCanvasPanel v-model="isOpen" width="650px" mobile-height="100dvh">
            <!-- Header -->
            <template #header>
                <span class="font-medium text-base text-[#0F1114]">
                    {{
                        currentStep === 1
                            ? 'درخواست جدید'
                            : 'بررسی اطلاعات درخواست'
                    }}
                </span>
            </template>

            <!-- Step 1: Form -->
            <CreateRequestForm v-if="currentStep === 1" :values="formValues" :countries="countries"
                :currencies="currencies" :discount-options="discountOptions" :transfer-methods="transferMethods"
                @submit="onFormSubmit" />

            <!-- Step 2: Preview -->
            <CreateRequestPreview v-else :values="formValues" />

            <!-- Footer -->
            <template #footer>
                <div class="flex justify-end gap-2">
                    <Button v-if="currentStep === 2" type="button" label="بازگشت" variant="outline" :isAdmin="true"
                        class="w-fit h-11 px-6!" size="sm" @click="onBack" />

                    <Button v-if="currentStep === 1" type="submit" form="create-requisition-form" label="ادامه"
                        :isAdmin="true" class="w-fit h-11 px-6!" size="sm" />

                    <Button v-else type="button" label="ثبت درخواست" :isAdmin="true" class="w-fit h-11 px-6!" size="sm"
                        @click="onCreateRequisition" />
                </div>
            </template>
        </OffCanvasPanel>
    </div>
</template>

<style scoped></style>
